<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="size_s" :height="size_s" viewBox="0 0 70 70">


        <circle class="fadeIn" fill="green" cx="35" cy="35" r="24"/>
        <circle class="drawCircle" stroke-dasharray="151"  cx="35" cy="35" r="24" stroke="white" stroke-width="3" stroke-linecap="round" fill="transparent"/>
        <circle class="drawCircle" stroke-dasharray="180" cx="35" cy="35" r="26" stroke="#e5e5e5" stroke-width="2" stroke-linecap="round" fill="transparent"/>
        <circle class="drawCircle" stroke-dasharray="180" cx="35" cy="35" r="28" stroke="#cecece" stroke-width="2" stroke-linecap="round" fill="transparent"/>

        <g class="scaleInOut">
            <g transform="translate(21 20) scale(1)"  fill="white" >
                <path class="" d="M9.838,6.951c0-2.414,1.965-4.374,4.374-4.374c2.411,0,4.374,1.96,4.374,4.374v4.56h2.573v-4.56
			C21.16,3.116,18.044,0,14.212,0c-3.829,0-6.948,3.116-6.948,6.951v1.56h2.574V6.951z"/>

                <path  class="" d="M22.586,12.97H5.843c-0.705,0-1.287,0.582-1.287,1.293v12.875c0,0.708,0.582,1.29,1.287,1.29h16.743
			c0.705,0,1.285-0.582,1.285-1.29V14.263C23.872,13.552,23.292,12.97,22.586,12.97z"/>
            </g>
        </g>

    </svg>
</template>

<script>
    import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import {enum_screenSizesOptions_n} from "../../../functions/src/shareCode/Share_S_Enum";

    export default {
        name: "si_finishRiddle",
        props:{
            direction:{
                type: String,
                default: 'rtl'
            },
            p_screenSize_en:{
                type:Number,
                require: true,
                validator(val) {
                    return validator_enum_fb(enum_screenSizesOptions_n, val)
                }

            }
        },
        data(){
            return {
                size_s : "100px"
            }

        },
        created(){
            switch(this.p_screenSize_en){
                case enum_screenSizesOptions_n.laptop:
                case enum_screenSizesOptions_n.tablet_big:
                case enum_screenSizesOptions_n.tablet_small:
                    this.size_s = "220px"
                    break;
                case enum_screenSizesOptions_n.mobile:
                    this.size_s = "100px"
                    break;

            }
        }


    }
</script>

<style scoped lang="scss">

    // drawCircle
    @keyframes scaleAnimation {
        0% {
            opacity: 0;
            transform: scale(1.5);
        }
        100% {
            opacity: 1;
            transform: scale(1);
        }
    }
    @keyframes scaleInOut {
        0% {
            transform: scale(0.9);
            opacity: 0;
        }
        50% {
            transform: scale(1.1);
            opacity: 1;
        }
        100% {
            transform: scale(1);
        }
    }
    @keyframes drawCircle {
        0% {
            stroke-dashoffset: 151px;
        }
        100% {
            stroke-dashoffset: 0;
        }
    }
    @keyframes fadeOut {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }
    @keyframes fadeIn {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }


    .fadeIn {
        animation: 0.3s linear 0.9s both fadeIn;
    }

    .scaleInOut1{
        animation: 1s ease-out 0s 1 both scaleInOut;
        transform-origin: center;
    }
    .scaleInOut{
        animation: 1s ease-out 1s 1 both fadeIn;
        transform-origin: center;
    }


    .drawCircle {
        animation: 1s cubic-bezier(0.77, 0, 0.175, 1) 0s 1 both drawCircle,
        0.3s linear 0.9s 1 both;
    }






</style>